const MCO = require('./MCO');
const MLA = require('./MLA');
const MLB = require('./MLB');
const MLC = require('./MLC');
const MLM = require('./MLM');
const MLU = require('./MLU');
const MPE = require('./MPE');

module.exports = {
  MCO,
  MLA,
  MLB,
  MLC,
  MLM,
  MLU,
  MPE,
};
